module.exports = __webpack_public_path__ + "static/media/affin.2d7ed9dd.png";